// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"styles_dashboard__2LUdc"};